/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Error_KeyInputs */

const en_ui_intervals_error_key = /** @type {(inputs: Ui_Intervals_Error_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu didn't accept this key. Check it, or create a new one in Developer Settings.`)
};

const de_ui_intervals_error_key = /** @type {(inputs: Ui_Intervals_Error_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu hat diesen Key nicht akzeptiert. Prüfe ihn oder erstelle einen neuen in den Developer Settings.`)
};

/**
* | output |
* | --- |
* | "intervals.icu didn't accept this key. Check it, or create a new one in Developer Settings." |
*
* @param {Ui_Intervals_Error_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_error_key = /** @type {((inputs?: Ui_Intervals_Error_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Error_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_error_key(inputs)
	return de_ui_intervals_error_key(inputs)
});